import React from 'react';
// Corrige la ruta de importación
import '../styles.css';

const Button = ({ type, children, onClick }) => {
  let className;
  switch (type) {
    case 'primary':
      className = 'btn-primary';
      break;
    case 'secondary':
      className = 'btn-secondary';
      break;
    case 'yellow-gold':
      className = 'btn-yellow-gold';
      break;
    default:
      className = 'btn-primary';
  }
  return <button className={className} onClick={onClick}>{children}</button>;
};

export default Button;
